import styled from 'styled-components'

import { media, phoneModalPaddingSize } from 'components/presentational/index'

export const LayoutPaddingBottom = styled.div`
  display: flex;
  flex-grow: 1;
  padding-bottom: ${phoneModalPaddingSize}px;
  box-sizing: border-box;

  ${media.tablet`
    padding-bottom: 10px;
  `}

  ${media.phone`
    padding-bottom: 0;
  `}
`
